class Organization {
    constructor(request) {
        this.request = request;
        this.endpoint = "organization"
    }

    SearchText = (searchText) => {
        const body = {
            "searchtext": searchText
        }

        return this.request.send(
            `search/${this.endpoint}/`,
            'POST',
            body
        )
    }
}

export default Organization;